import Project1 from '../../assets/images/Project1.png'
import Project1a from '../../assets/images/Project1a.png'
import Project1b from '../../assets/images/Project1b.png'
import Project1c from '../../assets/images/Project1c.png'
import Project1d from '../../assets/images/Project1d.png'
import Project1e from '../../assets/images/Project1e.png'
import Project1f from '../../assets/images/Project1f.png'
import Project1g from '../../assets/images/Project1g.png'
import Project2 from '../../assets/images/Project2.png'
import Project2a from '../../assets/images/Project2a.png'
import Project2b from '../../assets/images/Project2b.png'
import Project2c from '../../assets/images/Project2c.png'
import Project2d from '../../assets/images/Project2d.png'
import Project2e from '../../assets/images/Project2e.png'
import Project3 from '../../assets/images/Project3.png'
import Project3a from '../../assets/images/Project3a.png'
import Project3b from '../../assets/images/Project3b.png'
import Project3c from '../../assets/images/Project3c.png'
import Project3d from '../../assets/images/Project3d.png'
import Project3e from '../../assets/images/Project3e.png'
import Project4 from '../../assets/images/Project4.png'
import Project4a from '../../assets/images/Project4a.png'
import Project4b from '../../assets/images/Project4b.png'
import Project4c from '../../assets/images/Project4c.png'
import Project4d from '../../assets/images/Project4d.png'

export const projectList = [
  {
    name: 'Cinematch',
    image: Project1,
    skills: 'React + vite, SockIO, JavaScript, HTML, CSS, Springboot, MySQL',
    images: [
      { url: Project1 },
      { url: Project1a },
      { url: Project1b },
      { url: Project1c },
      { url: Project1d },
      { url: Project1e },
      { url: Project1f },
      { url: Project1g },
    ],
  },
  {
    name: 'Off-Road Online Shop',
    image: Project3,
    skills: 'JavaScript, HTML, CSS, Servlet, Filter, MySQL',
    images: [
      { url: Project3 },
      { url: Project3a },
      { url: Project3b },
      { url: Project3c },
      { url: Project3d },
      { url: Project3e },
    ],
  },
  {
    name: 'Pet Places',
    image: Project2,
    skills: 'AdobeXD, HTML, CSS, JavaScript',
    images: [
      { url: Project2 },
      { url: Project2a },
      { url: Project2b },
      { url: Project2c },
      { url: Project2d },
      { url: Project2e },
    ],
  },
  {
    name: 'Daily Cost App',
    image: Project4,
    skills: 'React, Node.js, Express, JavaScript, HTML, CSS',
    images: [
      { url: Project4 },
      { url: Project4a },
      { url: Project4b },
      { url: Project4c },
      { url: Project4d },
    ],
  },
]
